import { HAObject } from "../HAObject";
import { HARouter } from "../Route/Router";
import { toMap } from "../../../HA";

export class Repository extends HAObject {

    public cache(data: Map<any, any>, entity: any) {
        this.getCache().set(this.cacheKey(data), entity);
    }

    protected delFromCache(id: string) {
        return this.getCache().delete(id);
    }

    public clearCache(): void {
        this.addToData("cache", new Map());
    }

    protected getFromCache(data: Map<any, any>) {
        return this.getCache().get(this.cacheKey(data));
    }

    protected isCached(data: Map<any, any>): boolean {
        const id = data.get("id") ?? null;
        if (!id) return false;
        return this.getCache().has(this.cacheKey(data));
    }

    /**
     * Clé de cache. Par défaut le seul `id` (comportement historique). Les
     * repositories dont une même entité a plusieurs variantes paramétrées
     * (ha/508 : pages détail `?reference=…` partageant un pageId) surchargent
     * pour discriminer.
     */
    protected cacheKey(data: Map<any, any>): any {
        return data.get("id") ?? null;
    }

    protected getCache() {
        return this.get("cache");
    }

    protected request(data: Map<any, any>): Promise<any> {
        return this.getRouter().post(data);
    }

    protected requestGet(data: Map<any, any>): Promise<any> {
        return this.getRouter().doGet(data);
    }

    protected getRouter(): HARouter {
        if (this.hasNot("router")) {
            this.addToData("router", new HARouter());
        }
        return this.get("router");
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.addToData("cache", new Map());
    }
}
